import { unitMetaFromUnits } from './expensesCsv';

const csvMoney = n => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0.00';
  return num.toFixed(2);
};

export const formatInstallmentDuration = duration =>
  (duration || [])
    .map(d => `${d.year}-${String(d.month).padStart(2, '0')}`)
    .join(', ');

export const mapInstallmentsToCsvRows = ({ rows, units, propertyName } = {}) => {
  const unitMeta = unitMetaFromUnits(units);
  return (rows || []).map(r => {
    const unitId = String((r && r.unitId) || '');
    const meta = unitMeta[unitId] || {};
    return {
      'Property Name': propertyName || meta.propertyName || '',
      'Room Type': meta.roomTypeName || '',
      'Unit Name': meta.unitName || unitId,
      Label: (r && r.label) || '',
      'Monthly Payment': csvMoney(r && r.amount),
      Duration: formatInstallmentDuration(r && r.duration),
      Currency: 'MYR',
    };
  });
};
